export default "__VITE_ASSET__f233bcdd__"